import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import IntractionActionsList from '../../components/IntractionActionsList'
import StagesManager from '../../components/StagesManager'
import FixedView from '../../components/FixedView'

export default class NotebookView extends Component {


    functionsHandler = (type, name, data) => {
        this.props.functionsHandler(type, name, data)
        this.fiexView?.hideView()
    }

    changePageSubMenu = (title) => {
        this.stageManager.changeStage(title)
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.view = el} onClick={() => { this.viewView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('notebook.View')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={(el) => (this.viewView = el)} nodeRef={this.view} xOffset={this.props.language == "fa" ? 170 : -10} bottomOffset={0} topOffset={0} maxWidth={300}   >
                    <div className="bg-white br-10 p-1 shadow-3">
                        <StagesManager ref={(el) => (this.stageManager = el)} height={"100%"} fast={true}   >
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={"view"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}  >
                                <div className="mb-2">
                                    <IntractionActionsList language={this.props.language} onClick={() => this.changePageSubMenu("Mode")} data={{ title: "{{lang}}notebook.Mode", sub: true, icon: "/assets/icons/note/view/mode.svg" }} />
                                </div>
                                <div className="pt-2" style={{ borderTop: "1px solid #eee" }}  >
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Show print Layout", check: true }} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Show ruler", check: true }} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Show outline", check: true, shortcut: "Ctrl+Alt+A" }} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Show equation toolbar" }} />
                                    <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Show non-printing characters", shortcut: "Ctrl+Shift+P" }} />
                                </div>
                            </div>
                            <div width={this.props.width} isLoading={this.props.isLoading} stage={1} stageName={"Mode"} className=" p-1 sc-gray2" style={{ maxHeight: "350px", overflowY: "auto" }}  >
                                <div className="">
                                    <div className="pb-2">
                                        <button className="flexc w-100 hover-gray p-2 br-10" onClick={this.lastPage}   >
                                            <img width={18} src="/assets/icons/arrow-left-gray.svg" className="rtl-button" />
                                            <p className="font-size-13 weight-500 mld-3 main-c3 text-start">   {translate("notebook.Mode")}   </p>
                                        </button>
                                    </div>
                                    <div className="pt-2" style={{ borderTop: "1px solid #eee" }}  >
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Editing", icon: "/assets/icons/note/view/mode.svg", des: "{{lang}}notebook.Edit document directly" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Suggesting", icon: "/assets/icons/note/view/mode.svg", des: "{{lang}}notebook.Edit become suggestions" }} />
                                        <IntractionActionsList language={this.props.language} data={{ title: "{{lang}}notebook.Viewing", icon: "/assets/icons/note/view/mode.svg", des: "{{lang}}notebook.Read or print final document" }} />
                                    </div>
                                </div>
                            </div>
                        </StagesManager>
                    </div>
                </FixedView>
            </>
        )
    }
}
